import { render, staticRenderFns } from "./HypothesisTest.vue?vue&type=template&id=cc7e1f54&scoped=true&"
import script from "./HypothesisTest.vue?vue&type=script&lang=js&"
export * from "./HypothesisTest.vue?vue&type=script&lang=js&"
import style0 from "./HypothesisTest.vue?vue&type=style&index=0&id=cc7e1f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7e1f54",
  null
  
)

export default component.exports